export default __webpack_public_path__ + "static/10-46342b43153e79d3a7ae9f62db102c21.webp";